<div class="modalHeader">
  
</div>

<div class="modalContainer">
 <div class="item">
                
                
                    <img class="itemImg" [src]="item.thumbnail || dummyImg" alt="Subscription Category Image" />
                    
                    <div class="itemTitle">{{ item.title }}</div>
                    <div class="itemDesc">{{ item.description }}</div>

                </div>
</div>

<div class="modalFooter">
<!-- <app-button class="buttonV1 deleteBtnSmall" (buttonClick)="learnMore()" [color]="'white'">
{{"Learn More" | translate}}
</app-button> -->
    <app-button class="buttonV1" (buttonClick)="dismiss()" [color]="'danger'">
        <ion-icon class="appBtnIcon" src="../../../assets/svg/close.svg"></ion-icon>
</app-button>

</div>


